var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, C, HardDriveIcon, Trans, Typography, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { FilespaceListItemTestIdFactory } from './interactions';
import styles from './FilespaceListItemBase.module.css';
export const FilespaceListItemDisabled = ({ filespace, }) => {
    const filespaceName = filespace.name;
    return (_jsxs(Box, { align: "center", className: C(styles.IconAndNameContainer, styles.IconAndNameContainerDisabled), "data-testid": FilespaceListItemTestIdFactory.getFilespaceListItemTestId(filespace.id), gap: "s", isFullWidth: true, padding: "sm", radius: "sm", children: [_jsx(HardDriveIcon, { size: "small" }), _jsx(Typography, { className: PII_MASK_CLASS, color: "inherit", "data-testid": "filespace-name", kind: "generic", children: filespaceName }), _jsx(Box, { isVisuallyHidden: true, children: _jsx(Trans, { children: "Unavailable" }) })] }));
};
_react_refresh_temp_1 = FilespaceListItemDisabled;
$RefreshReg$(_react_refresh_temp_1, "FilespaceListItemDisabled");
